import { DrivingLessonRecordState } from '@evidia/shared';
import dayjs from 'dayjs';
import styled from 'styled-components';

const Container = styled.div`
	display: grid;

	grid-template-areas:
		'title title title title'
		'date  time  car   name';

	grid-template-columns: 50px 50px max-content 100px;
	padding: 0 5px;
	column-gap: 10px;
`;

const Title = styled.div<{ $error?: boolean }>`
	grid-area: title;

	color: ${({ $error }) => ($error ? '#FF4D4F' : '#595959')};
	font-size: 14px;
	line-height: 22px;
`;

const Date = styled.div`
	grid-area: date;
`;

const Time = styled.div`
	grid-area: time;
`;

const Car = styled.div`
	grid-area: car;
`;

const Name = styled.div`
	grid-area: name;
	justify-self: flex-end;
`;

type Props = {
	car: string;
	lessons?: number[];
	lecturer: string;
	date: Date;
	state: DrivingLessonRecordState;
};

export const TrainingItem = ({ car, lecturer, date, state, lessons }: Props) => {
	const getTitleText = () => {
		switch (state) {
			case DrivingLessonRecordState.CANCELLED_BY_STUDENT:
				return 'Zrušeno žákem';
			case DrivingLessonRecordState.CANCELLED_BY_TEACHER:
				return 'Zrušeno učitelem';
			case DrivingLessonRecordState.COMPLETED:
				return lessons ? `Jízda ${lessons.map(l => l + 1).join('-')}` : 'Dokončeno';
			case DrivingLessonRecordState.SCHEDULED:
				return 'Naplánováno';
			default:
				return 'Neznámý stav';
		}
	};
	return (
		<Container>
			<Title
				$error={
					state === DrivingLessonRecordState.CANCELLED_BY_STUDENT ||
					state === DrivingLessonRecordState.CANCELLED_BY_TEACHER
				}
			>
				{getTitleText()}
			</Title>
			<Date>{dayjs(date).format('D.M.YY')}</Date>
			<Time>{dayjs(date).format('HH:mm')}</Time>
			<Car>{car}</Car>
			<Name>{lecturer}</Name>
		</Container>
	);
};
